// api
import { VoucherService } from "@/api/voucher-service";
import DeleteDialog from "@core/components/delete-dialog/DeleteDialog.vue";
import { arClient } from "@/api/ar-client";
import ConfirmDialog from "@core/components/confirm-dialog/ConfirmDialog.vue";
import FormItems from "../ultils/Form/FormItems.vue";
import { AR_DPA01, AR_RPA02 } from "../../../api/constant";
import PermissionButton from "../ultils/Button/PermissionButton.vue"

import SearchList from "../ultils/SearchList/SearchList.vue";
import SectionTransformTable from "../ultils/Section/SectionTransformTable.vue";
import EzTable from "../ultils/Table/EzTable.vue";
import { DxDataGrid, DxColumn, DxSelection } from "devextreme-vue/data-grid";
import ModalQuickAction from "./components/ModalQuickAction.vue";
import "devextreme/dist/css/dx.light.css";
import ModalBoxAddNew from "./components/ModalBoxAddNew.vue";
import SidebarViewPayment from "./components/SidebarViewPayment/SidebarViewPayment.vue";
import ModalDistributionAccount from "./components/ModalDistributionAccount/ModalDistributionAccount.vue";
import { useFetch } from "../ultils/Hooks/useFetch.ts";
import { AR_IDA01,AR_IQA01,AR_IPA01,AR_RPA03 } from "../../../api/constant";

import {
  ArPaymentDistributionStatus,
  ArPaymentStatus,
  PaymentDetailTypeStatus,
  convertPaymentDetailTypeStatus,
  convertArPaymentDistributionStatus,
  convertArPaymentStatus,
} from "../ultils/status";
import { defineComponent, getCurrentInstance, ref } from "@vue/composition-api";

const dataGridRef = "tableRate";

export default defineComponent({
  components: {
    PermissionButton,
    SearchList,
    ModalQuickAction,
    FormItems,
    SectionTransformTable,
    EzTable,
    ModalBoxAddNew,
    DeleteDialog,
    ConfirmDialog,
    DxDataGrid,
    DxColumn,
    SidebarViewPayment,
    DxSelection,
    ModalDistributionAccount,
  },
  setup(props, { refs }) {
    const dataViewDetailsPayment = ref(null);
    const isShowDetailsInvoiceDetail = ref(false);
    const isShowModalDistributionAccount = ref(false);
    const vm = getCurrentInstance().proxy;

    function refetchData() {
      refs[dataGridRef].fetchData();
    }
    const { fetchData: fetchDataDetail, isLoading: isFetchDetailDataLoading } = useFetch(
      arClient.api_AR_RPA02,
      {
        showLoading: true,
        loadingMessage: "ar_common_get_detail",
        disableSuccessMessage: true,
      }
    );
    const {
      fetchData: createPayment,
      isError: isCreatePaymentError,
      isLoading: isCreatePayment,
    } = useFetch(arClient.api_AR_IPAD01, {
      nextFunction: () => {
        vm.$bvModal.hide("modal-payment-for-distribution");
      },
      showLoading: true,
    });
    const {
      fetchData: createBill,
      isError: isCreateBillError,
      errorCode: billErrorCode,
      errorMessage: billErrorMessage,
    } = useFetch(arClient.api_AR_IPA01, {
      showLoading: true,
      successMessage: "ar_client_create_bill_success",
    });
    const { fetchData: acceptData_AR_IDA01, isLoading: isCreateDistribution } = useFetch(
      arClient.api_AR_IDA01,
      {
        showLoading: true,
        nextFunction: () => {
          refetchData();
          isShowModalDistributionAccount.value = false;
        },
      }
    );
    const { fetchData: removeListArPay } = useFetch(arClient.api_AR_DPA01, {
      nextFunction: () => {
        refetchData();
        isShowDetailsInvoiceDetail.value = false;
        dataViewDetailsPayment.value = null;
      },
      showLoading: true,
      successMessageMessage: "ar_client_delete_success",
    });

    return {
      AR_RPA03,
      AR_IDA01,
      AR_IPA01,
      AR_IQA01,
      isCreatePayment,
      isFetchDetailDataLoading,
      dataViewDetailsPayment,
      isShowDetailsInvoiceDetail,
      fetchDataDetail,
      isShowModalDistributionAccount,
      createPayment,
      createBill,
      billErrorCode,
      billErrorMessage,
      isCreateDistribution,
      isCreateBillError,
      isCreatePaymentError,
      acceptData_AR_IDA01,
      refetchData,
      removeListArPay,
    };
  },
  provide: {
    codeErrorMsg: "",
    externalError: false,
  },
  data() {
    const vm = this
    return {
      isShowQuickActionModal: false,
      range: null,
      listPaymentHistory: [],
      dataArClient: [],
      KeyWord: null,
      ClientType: null,

      startDateSeach: this.getUTC("start", "month"),
      endDateSeach: this.getUTC("end", "month"),
      isShowModalAddNew: false,

      isLoading: true,
      perPage: 10,
      dataGridRef: "tableRate",

      actions: [
        {
          apiCode:AR_RPA02,
          title: "ar_common_detail",
          icon: "eye",
        },
        {
          apiCode: AR_DPA01,
          danger: true,
          icon: "trash",
          dialogContent: (data) => {
            return this.$t("ar_client_confirm_delete_ar_payment") + " " + data?.data?.ArPaymentCode;
          },
          title: "ar_common_delete",
        },
      ],
      columns: [
        {
          caption: "ar_client_payment_code",
          field: "ArPaymentCode",
          minWidth: 130,
        },
        {
          caption: "ar_client_payment_type",
          field: "PaymentDetailType",
          defaultIfEmpty: this.$t("ar_client_top_up"),
          cellTemplate: true,
          formatType: "text-variant",
          renderTextVariant: convertPaymentDetailTypeStatus,
          minWidth: 120,
        },
        {
          caption: "ar_client_company_code",
          field: "TravelAgentCode",
          minWidth: 130,
        },

        {
          caption: "ar_voucher_company_name",
          field: "NameVi",
          minWidth: 180,
        },

        {
          caption: "ar_client_receipt_status",
          field: "PaymentStatus",
          formatType: "text-variant",

          cellTemplate: true,
          minWidth: 120,
          renderTextVariant: convertArPaymentStatus,
        },
        {
          caption: "ar_client_allotment_states",
          field: "DistributionStatus",
          minWidth: 120,
          cellTemplate: true,
          formatType: "text-variant",
          renderTextVariant: convertArPaymentDistributionStatus,
        },

        {
          caption: "ar_client_total_money",
          field: "TotalAmount",

          cellTemplate: true,
          formatType: "currency",
        },
        {
          caption: "ar_client_distribution_money_number",
          field: "DistributionAmount",

          cellTemplate: true,
          formatType: "currency",
        },
        {
          caption: "ar_client_payer",
          minWidth: 80,
          field: "Payer",
        },
        {
          caption: "ar_client_payment_date",
          formatType: "date",
          dateConfig: {
            showTime: true,
          },
          minWidth: 100,
          cellTemplate: true,
          field: "ArPaymentDate",
        },

        {
          caption: "ar_client_created_person",
          field: "CreateBy",
          cellTemplate: true,
          minWidth: 150,
          cellRender(data) {
            return `${data.data.CreateBy} - ${data.data.CreateByName} ${data.data.CreateByStatus === 0 ? `(${vm.$t("ar_client_in_active")})` : ""}`;
          },
        },
        {
          caption: "ar_voucher_create_date",
          formatType: "date",
          dateConfig: {
            showTime: true,
          },
          cellTemplate: true,
          minWidth: 100,
          field: "CreatedDate",
        },
      ],
      detailRowIndex: 0,
      dataTableListPay: [],
      isUpdatePayment: false,

      dataGridRef: "tableRate",
      searchVal: {
        FromDate: undefined,
        ToDate: undefined,
        TravelAgentId: null,
        DateType: "CreateDate",
        TravelAgentId: null,
        PaymentStatus: null,
        DistributionStatus: null,
        PaymentCode: null,
        CashierCode: null,
      },
      dataRefill: null,
      dataRefillForBill: null,
      listAllotmentStates: [
        { value: "INPROCESS", name: this.$t("ar_client_inprocess") },
        { value: "NO", name: this.$t("ar_client_not_allotment") },
        { value: "FULL", name: this.$t("ar_client_allotted") },
      ],

      listCashier: [],
      cashierVal: null,
      listPayment: [],

      isShowModalDistributionDept: false,
      clientIdSelected: 0,
      listSelectedRow: [],
      isSelectedAllAccount: false,
    };
  },
  methods: {
    showModalPopupAddNew() {
      this.isShowModalAddNew = !this.isShowModalAddNew;
    },
    distributePayment() {
      const isSelectPayment = this.listSelectedRow.length > 0;

      const noReceiptList = [];

      const fullDistributedList = [];

      if (!isSelectPayment) {
        this.showToast("error", this.$t("ar_distribution_err_msg_01"));
        return;
      }
      this.listSelectedRow.forEach((row) => {
        if (row.TotalAmount === 0) {
          noReceiptList.push(row.ArPaymentCode);
        }
      });
      this.listSelectedRow.forEach((row) => {
        if (row.DistributionStatus === "FULL") {
          fullDistributedList.push(row.ArPaymentCode);
        }
      });
      if (noReceiptList.length > 0) {
        this.showToast(
          "error",
          this.$t("ar_client_payment_no_receipt", { paymentList: noReceiptList.join(", ") })
        );
        return;
      }
      if (fullDistributedList.length > 0) {
        this.showToast(
          "error",
          this.$t("ar_client_payment_full_distributed", {
            paymentList: fullDistributedList.join(", "),
          })
        );
        return;
      }

      this.isShowModalDistributionAccount = true;
    },

    async fetchDataDetailsArPayment(value) {
      const body = {
        ArPayment: {
          Id: value,
        },
      };

      await this.fetchDataDetail(body).then((data) => {
        this.dataViewDetailsPayment = data;
        if (!this.dataViewDetailsPayment.ArClientName) {
          const matchingClient = this.dataArClient.find(
            (item) => item.Id === this.dataViewDetailsPayment.ArTravelAgentId
          );
          this.dataViewDetailsPayment.ArClientName = matchingClient?.ClientName;
        }

        this.isShowDetailsInvoiceDetail = true;
      });
    },

    async addDataBill(value) {
      const data = {
        ArPayment: {
          ...value,
        },
      };
      await this.createBill(data).then((data) => {
        if (this.isCreateBillError) {
          return;
        }
        this.isShowModalAddNew = false;
        this.refetchData();
        this.fetchDataDetailsArPayment(data.ArPaymentId);
      });
    },

    async viewDetailListVoucher(value) {
      const { column, data, rowIndex } = value;
      const arrayBannedCellTemplate = ["Action", "selection", "selectionCellTemplate"];
      this.detailRowIndex = rowIndex;
      if (
        arrayBannedCellTemplate.includes(column.cellTemplate) ||
        arrayBannedCellTemplate.includes(column.cellTemplate.name)
      ) {
        return;
      }
      await this.fetchDataDetailsArPayment(data.Id);
    },
    showModalEditAddNew(value) {
      this.dataRefill = {
        ...value,
      };
      this.isShowModalAddNew = true;
    },
    async addDataEdit(data, Id) {
      const body = {
        ArPayment: {
          Id,
          ...data,
        },
      };
      await arClient.api_AR_UPA01(body).then((res) => {
        this.showResToast(res);
        if (res.Status !== "200") {
          return;
        }
        this.isShowModalAddNew = false;
        this.refetchData();
        this.fetchDataDetailsArPayment(Id);
        this.dataRefill = null;
      });
    },
    async addListPaymentForinvoiceDetail(value) {
      const body = {
        ArPaymentDetail: {
          ...value,
        },
      };

      await this.createPayment(body).then(() => {
        if (this.isCreatePaymentError) return;

        const { Id } = this.dataViewDetailsPayment;
        this.refetchData();
        this.fetchDataDetailsArPayment(Id);
      });
    },
    async delListArPaymentDetail(id) {
      const body = {
        ArPaymentDetail: {
          Id: id,
        },
      };
      await arClient.api_AR_DPAD01(body).then((res) => {
        this.showResToast(res);
        if (res.Status !== "200") {
          return;
        }
        const { Id } = this.dataViewDetailsPayment;
        this.fetchDataDetailsArPayment(Id);
        this.refetchData();
      });
    },
    async fetchDataReadBill(id) {
      const body = {
        ArPaymentDetail: {
          Id: id,
        },
      };
      await arClient.api_AR_RPAD01(body).then((res) => {
        if (res.Status !== "200") {
          this.showResToast(res);
          return;
        }

        this.dataRefillForBill = res.Data;
      });
    },
    async acceptEditForBillPayment(data) {
      this.isUpdatePayment = true;
      const body = {
        ArPaymentDetail: {
          ...data,
        },
      };
      await arClient.api_AR_UPAD01(body).then((res) => {
        this.isUpdatePayment = false;
        this.showResToast(res);
        if (res.Status !== "200") {
          return;
        }

        this.$bvModal.hide("modal-payment-for-distribution");
        const { Id } = this.dataViewDetailsPayment;
        this.fetchDataDetailsArPayment(Id);
        this.refetchData();
      });
    },

    deSelectedPayment(ArClientId) {
      this.dataTableListPay.forEach((item, index) => {
        if (item.ArTravelAgentId === ArTravelAgentId) {
          this.tableInstance.deselectRows([this.tableInstance.getKeyByRowIndex(index)]);
        }
      });
    },
    selectPayment(value) {
      if (value.selectedRowsData.length === 0) {
        this.listSelectedRow = [];
        return;
      }
      const listDataSelected = this.tableInstance.getSelectedRowsData();

      const selectedRowsListId = listDataSelected.map((item) => item.TravelAgentId);
      const newSelectedId = value.selectedRowKeys[value.selectedRowKeys.length - 1].TravelAgentId;

      if (selectedRowsListId[0] === newSelectedId) {
        this.tableInstance.selectRows(
          [value.selectedRowKeys[value.selectedRowKeys.length - 1]],
          true
        );
      } else {
        this.tableInstance.selectRows(
          [value.selectedRowKeys[value.selectedRowKeys.length - 1]],
          false
        );
      }

      this.listSelectedRow = [...listDataSelected];
    },
  },

  watch: {
    isShowModalAddNew(value) {
      if (!value) {
        this.dataRefill = null;
      }
    },
  },
  computed: {
    windowWidth() {
      return window.innerWidth;
    },
    formItems() {
      return [
        {
          type: "string",
          name: "PaymentCode",
          label: "ar_client_payment_code",
          placeholder: "ar_client_payment_code",
          wrapperClass: "col-2",
        },
        {
          type: "select",
          name: "TravelAgentId",
          dataSource: this.arClient.api_AR_RCL01,
          multiple: true,
          dataSourceParams: {
            IsCheckPermission: false,
          },
          customOptions: (options) =>
            options.map((option) => ({
              ...option,
              CodeName: `${option.TravelAgentCode} - ${option.NameVi}`,
            })),
          labelOption: "CodeName",
          label: "ar_client_company",
          placeholder: "ar_client_company",
          wrapperClass: "col-3",
        },
        {
          type: "select",
          name: "PaymentStatus",
          dataSource: ArPaymentStatus.map((i) => ({ ...i, title: this.$t(i.title) })),
          multiple: true,
          customReduce: "value",
          labelOption: "title",
          label: "ar_client_receipt_status",
          placeholder: "ar_client_receipt_status",
          wrapperClass: "col-3",
        },
        {
          type: "select",
          name: "DistributionStatus",
          dataSource: ArPaymentDistributionStatus.map((i) => ({ ...i, title: this.$t(i.title) })),
          multiple: true,
          customReduce: "value",
          labelOption: "title",
          label: "ar_client_allotment_states",
          placeholder: "ar_client_allotment_states",
          wrapperClass: "col-3",
        },
        {
          type: "select",
          name: "PaymentDetailType",
          dataSource: PaymentDetailTypeStatus.map((i) => ({ ...i, title: this.$t(i.title) })),
          multiple: true,
          customReduce: "value",
          labelOption: "title",
          label: "ar_client_payment_type",

          wrapperClass: "col-3",
        },
        {
          type: "select",
          name: "CashierCode",
          dataSource: this.arClient.api_AP_RTU01,
          dataSourceParams: {
            IsCheckPermission: false,
          },
          multiple: true,
          customOptions: (options) =>
            options.map((option) => ({
              ...option,
              CodeName: `${option.TaUserCode} - ${option.Fullname}`,
            })),
          labelOption: "CodeName",
          label: "ar_client_created_person",
          placeholder: "ar_client_created_person",
          wrapperClass: "col-3",
        },
        {
          type: "select",
          name: "DateType",
          dataSource: this.listDateType,

          labelOption: "Label",
          label: "ar_client_date_type",
          placeholder: "ar_client_date_type",
          wrapperClass: "col-2",
        },
        {
          type: "date",
          rangeData: ["FromDate", "ToDate"],
          name: "createdDate",

          isRange: true,
          placeholder: "ar_common_range",
          label: "ar_common_range",
          wrapperClass: "col-3",
        },
      ];
    },
    listDateType() {
      return [
        { Id: "CreateDate", Label: this.$t("ar_client_created_date") },
        { Id: "ArPaymentDate", Label: this.$t("ar_client_payment_date") },
      ];
    },

    tableInstance() {
      return this.$refs[dataGridRef].$refs.dxDatagridRef.instance;
    },
  },
});
